// Clickable row for one legal document on the Legal tab

function formatAcceptedDate(iso) {
  if (!iso) return null;
  try {
    return new Date(iso).toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  } catch {
    return null;
  }
}

export function LegalDocumentListItem({ document: legalDoc, onSelect, statusMeta }) {
  const status = statusMeta?.status ?? 'pending';
  const acceptedAt = formatAcceptedDate(statusMeta?.acceptedAt);

  let statusLabel = 'Not accepted';
  let statusClass = 'legal-document-list-item__status--pending';
  if (status === 'current') {
    statusLabel = acceptedAt ? `Accepted ${acceptedAt}` : 'Accepted';
    statusClass = 'legal-document-list-item__status--current';
  } else if (status === 'outdated') {
    statusLabel = 'Update required';
    statusClass = 'legal-document-list-item__status--outdated';
  }

  return (
    <button
      type="button"
      className="legal-document-list-item"
      onClick={() => onSelect(legalDoc)}
    >
      <span className="legal-document-list-item__icon" aria-hidden>
        <i className={legalDoc.listIconClass ?? 'fa-solid fa-file-lines'} />
      </span>
      <span className="legal-document-list-item__text">
        <span className="legal-document-list-item__label">{legalDoc.displayName}</span>
        <span className={`legal-document-list-item__status ${statusClass}`}>
          {statusLabel}
        </span>
      </span>
      <span className="legal-document-list-item__chevron" aria-hidden>
        <i className="fa-solid fa-chevron-right" />
      </span>
    </button>
  );
}
